<div aria-hidden="false" class="three-quarter bg-very-light-gray padding-reset v-center-content"
     data-events="resize" data-resize="detail-offre" id="detail-offre"
     style="display: block; top: 0;" tabindex="-1">
  <div class="cell shrink header medium-cell-block-container">
    <div class="hds-panel overflow-visible">
      <div class="hds-panel-detail-header">
        <div class="hds-panel-detail-header-main-container">
          <div class="hds-panel-detail-header-menu">
            <div class="hds-panel-detail-header-menu-list">
              <div class="hds-panel-detail-header-menu-list-item">
                <div class="hds-panel-detail-title-simple">
                  <h2 class="padding-t-xs padding-l c-dark-gray">
                    <span>{{'assistance.new-request' | translate}}</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hds-panel-detail-header-side-menu">
          <div class="hds-panel-detail-header-menu">
            <div class="hds-panel-detail-header-menu-list">
              <div class="hds-panel-detail-header-menu-list-item collapsed">
                <button class="close-button hover"
                        mat-dialog-close
                        aria-label="Close modal" style="height: 100%">
                  <i class="margin-all fal fa-times fa-1x"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="portfolios else spinner" class="cell medium-auto medium-cell-block-container">
    <div *ngFor="let portfolio of portfolios | sortByField: 'solution' : PortfolioSolutionsValues" class="hds-panel bg-white">
      <div class="hds-panel-body padding-reset">
        <div class="bg-very-light-gray margin-b">
          <h4 class="padding-1 margin-h font-bold">
              {{'assistance.portfolio.your-team.' + portfolio.solution | translate: {numberOfConsultants: portfolio.consultants.length} }}
          </h4>
        </div>
        <div *ngFor="let consultant of portfolio.consultants | sortByOrder" class="card padding-h-xl padding-v-s border-reset">
          <div class="grid-x">
            <div class="cell shrink margin-r-l"
                 style="width:70px;height:70px; border-radius: 45px; -webkit-border-radius: 45px; -moz-border-radius: 45px;"
                 [style.background]="'url('+ consultant.pictureUrl+') no-repeat center'" [style.background-size]="'contain'">
            </div>
            <div class="cell auto">
              <div style="display: flex;
                          flex-direction: column;
                          justify-content: center;
                          height: 100%;">
                <h4 class="c-dark-gray font-bold margin-b-xs">
                  {{consultant.firstname ? consultant.lastname + ' ' + consultant.firstname : consultant.lastname}}
                </h4>
                <p class="c-medium-gray margin-reset">{{consultant.jobTitle}}</p>
                <p *ngIf="consultant.phone"
                   class="c-neutral font-bold margin-reset">
                  <em class="opt opt-phone c-insito"></em>&nbsp;
                  {{consultant.phone}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-very-light-gray">
      <h4 class="padding-1 margin-h font-bold">
        {{'assistance.contact-your-consultant' | translate}}
      </h4>
    </div>

    <div class="card border-reset">
      <div class="card-body padding-h text-left">
        <form (ngSubmit)="onSendRequest()">
          <div class="row margin-h margin-v">
            <div class="border-radius-xlarge cell auto padding-h padding-v" style="background: #F7F9FA; border: 1px solid #E6E6E6">
              <div class="row margin-v">
                <div class="small-12 columns">
                  <h4 class="margin-b"><b>{{'assistance.assistance-type' | translate}} </b></h4>
                  <label class="option_label i-block margin-r info" for="consultantRequest">
                    <input [(ngModel)]="requestType" type="radio" name="consultantRequest" id="consultantRequest" [value]="ASSISTANCE_REQUEST_TYPES.CONSULTANT"/>
                    <i></i><span>{{'assistance.assistance' | translate}}</span>
                  </label>
                  <label class="option_label i-block info" for="backofficeRequest">
                    <input [(ngModel)]="requestType" type="radio" name="backofficeRequest" id="backofficeRequest" [value]="ASSISTANCE_REQUEST_TYPES.BACKOFFICE"/>
                    <i></i> <span>{{'update' | translate}}</span>
                  </label>
                </div>
              </div>

              <div class="row margin-v">
                <div class="small-12 columns">
                  <h4 class="margin-b"><b>{{'platforme' | translate}} </b></h4>
                  <label *ngFor="let application of userApplications" class="option_label i-block info margin-r" [for]="application.appId" (click)="onChangeFromApplication(application)">
                    <input [(ngModel)]="selectedUserApplicationForRequest" type="radio" [name]="application.appId" [id]="application.appId" [value]="application" [checked]="application === selectedUserApplicationForRequest"/>
                    <i></i> <span>{{application.name | applicationName}}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-all">
            <button type="submit" class="button info margin-r-xs border-radius-xlarge cell auto" [disabled]="!requestType || !selectedUserApplicationForRequest">{{'assistance.contact' | translate}}</button>
          </div>
        </form>
      </div>
    </div>

  </div>
  <ng-template #spinner>
    <div class="widget-spinner">
    </div>
  </ng-template>
</div>
